import { css } from "styled-components";
import { Backdrop } from "../../../../components/Backdrop";
import { BladeContent } from "../../../../components/BladeContent";
export const riotProductSkin = (chroma, paletteTokens) => css `
  ${chroma.mediaQueries.desktopUp} {
    padding-top: ${chroma.spacers.bladeEdge.top};
  }

  padding-bottom: ${chroma.spacers.bladeEdge.bottom};

  .banner {
    position: relative;
  }

  ${Backdrop} {
    object-fit: fill;
    top: auto;
    bottom: 20%;

    .background-image {
      position: relative;
      transform: scale(1.1);
      filter: blur(16px);
    }
  }

  ${chroma.mediaQueries.tabletDown} {
    ${Backdrop} {
      display: none;
    }

    ${BladeContent} {
      padding: 0;
    }
  }

  .banner-image {
    position: relative;
    margin: 0 auto;
    ${chroma.mediaQueries.tabletDown} {
      padding-top: 0;
      width: 100%;
      height: 100%;
    }
  }

  .content-container {
    position: relative;
    padding: ${chroma.spacers.variable.l} 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${chroma.spacers.variable.sm};

    .header {
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: ${chroma.spacers.variable.s};

      .title {
        ${chroma.typography.display5};
        text-wrap: balance;
      }

      .tagline {
        ${chroma.typography.body3};
      }
    }

    .divider {
      width: 100%;
      height: 4px;
      border-top: 2px solid ${paletteTokens.keyline};
      border-bottom: 1px solid ${paletteTokens.keyline};
    }

    .metadata-with-links {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: ${chroma.spacers.constant.s};
    }

    .metadata {
      ${chroma.typography.body5};
      display: flex;

      > * + *::before {
        padding: 0 ${chroma.spacers.constant.xs};
        color: ${paletteTokens.keyline};
        content: "|";
      }

      a:link {
        text-decoration: none;
        color: ${paletteTokens.accents1};
      }

      a:visited {
        color: ${paletteTokens.accents1};
      }

      .authors {
        display: flex;
        align-items: center;

        > span {
          text-align: center;
          word-break: break-word;
        }
      }
    }

    .social-links {
      display: flex;
      justify-content: center;
      gap: ${chroma.spacers.constant.xs};

      .icon {
        background-color: ${paletteTokens.accents1};
      }
    }
  }
`;
//# sourceMappingURL=index.js.map